import cx from 'classnames';
import { forwardRef } from 'react';

type MenuHeadingProps = {
  children: string;
  className?: string;
};
const MenuHeading = forwardRef<HTMLHeadingElement, MenuHeadingProps>(
  ({ children, className, ...rest }, ref) => {
    return (
      <h3
        ref={ref}
        className={cx(
          'px-4 caption-sm-light text-sm text-body md:text-base',
          className,
        )}
        {...rest}
      >
        {children}
      </h3>
    );
  },
);

MenuHeading.displayName = 'MenuHeading';

export default MenuHeading;
